<template>
<div class="marginalbot">

    <h4 style="text-align:center;">{{$ml.get('programcachetitle')}}</h4>

    <p class="marginal" style="text-justify: auto;" v-html="$ml.get('programcachep1')"></p>

    <h5 class="marginalbotsm" style="color:#2F90B0">{{$ml.get('programcachet2')}}</h5>
    
    <p class="marginalbot" style="text-justify: auto;" v-html="$ml.get('programcachep2')"></p>

    <p style="text-justify: auto;" v-html="$ml.get('programcachep3')"></p>
    <code class="myCode">Cache-Control: max-age=3, must-revalidate</code>

    <p class="marginaltop" style="text-justify: auto;" v-html="$ml.get('programcachep4')"></p>
    <code class="myCode">Cache-Control: max-age=86400, must-revalidate</code>
    
    <h5 class="marginaltop marginalbotsm" style="color:#2F90B0">{{$ml.get('programcachet3')}}</h5>

    <pre class="myCode">
server {
    # Your server config

    location / {
        # Your configuration 
        add_header Cache-Control 'max-age=3, must-revalidate' always;
    }
}
    </pre>

    <h5 class="marginaltop marginalbotsm" style="color:#2F90B0">{{$ml.get('programcachet4')}}</h5>

    <pre class="myCode">
&lt;filesMatch ".(m3u8|mpd)">
    Header set Cache-Control "max-age=3, must-revalidate"
&lt;/filesMatch>
&lt;filesMatch ".(m4s|mp4|ts|webm)">
    Header set Cache-Control "max-age=86400, must-revalidate"
&lt;/filesMatch>
    </pre>

</div>
</template>

<script>
import CDNService from '@/services/cdn.service.js'
let cdnService = new CDNService();
export default {
  name: "CDNDoc2",
  data: function () {
    return {
    };
  },
  mounted: function () {
  },
  methods: {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.myCode {
    border: solid 1px darkgrey;
    border-radius: 5px;
    background-color:rgba(0,0,0,0.1);
    color: #113448;
    padding: 5px 5px;
}

</style>
